import { AsyncPipe } from '@angular/common'
import { CommonModule } from '@angular/common'
import {
    Component,
    inject,
    input,
    output,
    ChangeDetectionStrategy,
} from '@angular/core'
import { Router } from '@angular/router'
import {
    AuthStateService,
    UserOrganizationStateService,
} from '@baboor/baboor-auth'
import { SubscriptionStateService } from '@baboor/baboor-subscription'
import { ProfileStateService } from '@baboor/baboor-user'
import { UserSettingsStateService } from '@baboor/baboor-user-setting'
import { AuthApiService } from '@baboor/common-auth'
import { NavigateButtonComponent } from '@baboor/common-components'
import { AlertService, ThemeService } from '@baboor/common-services'
import { WA_LOCATION } from '@ng-web-apis/common'
@Component({
    selector: 'app-client-profile-dropdown',
    imports: [AsyncPipe, NavigateButtonComponent, CommonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './client-profile-dropdown.component.html',
})
export class ClientProfileDropdownComponent {
    private router = inject(Router)
    private alertService = inject(AlertService)
    protected authStateService = inject(AuthStateService)
    private authApiService = inject(AuthApiService)
    private userSettingStateService = inject(UserSettingsStateService)
    protected profileStateService = inject(ProfileStateService)
    protected subscriptionStateService = inject(SubscriptionStateService)
    protected userGroupStateService = inject(UserOrganizationStateService)
    protected themeService = inject(ThemeService)
    private readonly location = inject(WA_LOCATION)

    isVisible = input(false)
    organization = input<any>(null)
    groupType = input<string>('')
    isLoading = input(false)
    isError = input(false)
    selectedGroupId = input<string | null>(null)

    close = output<void>()
    navigate = output<string>()
    switchGroup = output<string>()
    upgradeSubscription = output<string>()
    toggleTheme = output<void>()
    loadOwnedGroups = output<{
        wrapper: HTMLDivElement
        chevron: HTMLSpanElement
    }>()

    onToggleTheme() {
        this.toggleTheme.emit()
    }

    onNavigate(path: string) {
        this.navigate.emit(path)
    }

    onSwitchGroup(id: string) {
        this.switchGroup.emit(id)
    }

    onUpgradeSubscription(id: string) {
        this.upgradeSubscription.emit(id)
    }

    onLoadOwnedGroups(wrapper: HTMLDivElement, chevron: HTMLSpanElement) {
        this.loadOwnedGroups.emit({ wrapper, chevron })
    }

    onClose() {
        this.close.emit()
    }

    logout() {
        this.authStateService.logout()
        this.userSettingStateService.updateSetting('isPinCodeSet', false)
        this.location.assign('/login')
    }
}
